import request from '@/fetch/index'

/**
 * @param { String } districtId
 */
// 获取字典集合
export function getListCondition (params) {
  return request({
    url: `/api/loan/product/app/list-condition`,
    methods: 'GET',
    params
  })
}
